import { render, staticRenderFns } from "./AddMembers.vue?vue&type=template&id=0f87e6f5&scoped=true"
import script from "./AddMembers.vue?vue&type=script&lang=js"
export * from "./AddMembers.vue?vue&type=script&lang=js"
import style0 from "./AddMembers.vue?vue&type=style&index=0&id=0f87e6f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f87e6f5",
  null
  
)

export default component.exports